import { api } from './api';
import { FormDefinition } from '../../components/types';

export const formsApi = {
  async getForm(formId: string): Promise<FormDefinition> {
    try {
      console.log('Fetching form definition for ID:', formId);
      
      // Try to fetch form from the forms API endpoint
      const response: any = await api.get(`/forms/${formId}`);
      console.log('Form API response:', response);
      
      if (response?.data) {
        return response.data as FormDefinition;
      }
      
      // If no response or no data, return a fallback form
      throw new Error('No form data received');
    } catch (error) {
      console.warn('Failed to fetch form definition, using fallback:', error);
      
      // Return a mock form based on the formId for development/testing
      return createMockForm(formId);
    }
  }
};

function createMockForm(formId: string): FormDefinition {
  // Create different mock forms based on the formId
  if (formId.toLowerCase().includes('user') || formId.toLowerCase().includes('create')) {
    return {
      id: formId,
      title: 'Create User',
      description: 'Create a new user account in the system',
      fields: [
        {
          name: 'firstName',
          label: 'First Name',
          type: 'text',
          required: true,
          placeholder: 'Enter first name'
        },
        {
          name: 'lastName',
          label: 'Last Name',
          type: 'text',
          required: true,
          placeholder: 'Enter last name'
        },
        {
          name: 'email',
          label: 'Email Address',
          type: 'email',
          required: true,
          placeholder: 'user@company.com',
          validation: {
            pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$',
            message: 'Please enter a valid email address'
          }
        },
        {
          name: 'department',
          label: 'Department',
          type: 'select',
          required: true,
          options: [
            { value: 'engineering', label: 'Engineering' },
            { value: 'marketing', label: 'Marketing' },
            { value: 'sales', label: 'Sales' },
            { value: 'hr', label: 'Human Resources' },
            { value: 'finance', label: 'Finance' }
          ]
        },
        {
          name: 'role',
          label: 'Role',
          type: 'select',
          required: true,
          options: [
            { value: 'user', label: 'User' },
            { value: 'admin', label: 'Administrator' },
            { value: 'manager', label: 'Manager' }
          ]
        },
        {
          name: 'sendWelcomeEmail',
          label: 'Send welcome email',
          type: 'checkbox'
        },
        {
          name: 'notes',
          label: 'Additional Notes',
          type: 'textarea',
          placeholder: 'Any additional information about the user...'
        }
      ],
      submitButtonText: 'Create User'
    };
  } else if (formId.toLowerCase().includes('group')) {
    return {
      id: formId,
      title: 'Create Group',
      description: 'Create a new security group',
      fields: [
        {
          name: 'groupName',
          label: 'Group Name',
          type: 'text',
          required: true,
          placeholder: 'Enter group name'
        },
        {
          name: 'description',
          label: 'Description',
          type: 'textarea',
          required: true,
          placeholder: 'Describe the purpose of this group'
        },
        {
          name: 'groupType',
          label: 'Group Type',
          type: 'select',
          required: true,
          options: [
            { value: 'security', label: 'Security Group' },
            { value: 'distribution', label: 'Distribution Group' },
            { value: 'office365', label: 'Office 365 Group' }
          ]
        }
      ],
      submitButtonText: 'Create Group'
    };
  } else {
    // Generic form
    return {
      id: formId,
      title: `Form: ${formId}`,
      description: 'Please fill out the form below',
      fields: [
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          placeholder: 'Enter name'
        },
        {
          name: 'description',
          label: 'Description',
          type: 'textarea',
          placeholder: 'Enter description'
        },
        {
          name: 'priority',
          label: 'Priority',
          type: 'select',
          options: [
            { value: 'low', label: 'Low' },
            { value: 'medium', label: 'Medium' },
            { value: 'high', label: 'High' }
          ]
        }
      ],
      submitButtonText: 'Submit'
    };
  }
}
